var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0AC18E",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.743 7.97c-.603-1.367-1.989-1.66-3.685-1.376l-.546-2.114-1.285.332.536 2.108c-.338.085-.685.158-1.03.256L9.199 5.08l-1.285.332.545 2.114c-.277.08-2.595.673-2.595.673l.353 1.377s.944-.265.935-.244c.524-.137.77.125.886.372l1.499 5.792c.018.168-.012.454-.372.552.022.012-.935.24-.935.24l.14 1.605 2.598-.663.552 2.137 1.285-.331-.551-2.154a36.88 36.88 0 0 0 1.032-.256l.548 2.141 1.286-.331-.552-2.136c1.98-.48 3.378-1.73 3.092-3.64-.183-1.15-1.44-2.095-2.486-2.201.643-.57.969-1.401.57-2.488Zm-.618 5.041c.255 1.892-2.373 2.123-3.24 2.352l-.756-2.83c.87-.228 3.563-1.188 3.996.478ZM13.54 9.158c.271 1.682-1.977 1.877-2.702 2.062l-.688-2.567c.728-.18 2.839-1.051 3.39.505Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBch);
export default __webpack_public_path__ + "static/media/bch.f43523e9ef2e71fdebe41f0e2be2c451.svg";
export { ForwardRef as ReactComponent };